<ng-container *showOnlyInView="[ViewCategory.FA_PLUS]">
	<section class="scenario-analysis-container" *ngIf="data.success && !data.getTabById('scenarios.analysis').error">
		<section class="section-separator"></section>
		<div class="chart-header">
			<div class="margin-standard">
				<h3 class="title-main" dcrHTMLKey="SCENARIO_ANALYSIS_TITLE">Scenario Analysis</h3>
				<p class="text-16 color-secondary">
					<span dcrHTMLKey="AS_OF_DATE">As of&nbsp;</span> <span>{{ data.portfolioData[0].field['asOfDate'].formattedValue }}</span>
				</p>
				<div class="text-16">
					<p dcrHTMLKey="SCENARIO_ANALYSIS_SUB_TITLE">SCENARIO_ANALYSIS_SUB_TITLE</p>
					<p><a class="text-bold" (click)="openScenarioDetails($event)">Click here</a> to view details for the scenarios below.</p>
				</div>
			</div>
			<section class="row" *ngIf="portfolioSchemas?.length > 1; else onePortfolio">
				<section class="col-7 col-md-12 col-sm-24">
					<section class="ac-dropdown margin-standard">
						<label for="portfolio-name" class="text-12" dcrHTMLKey="ST_SHOW_IN_CHART_LABEL">Show in chart (select one)</label>
						<select required (change)="portfolioSelected($event)">
							<option class="text-16" [value]="-1" dcrHTMLKey="ALL_PORTFOLIOS">All Portfolios</option>
							<option [acSelectOption]="portfolioSchema.name" class="text-16" *ngFor="let portfolioSchema of portfolioSchemas; let i = index" [value]="i"> </option>
						</select>
					</section>
				</section>
			</section>

			<ng-template #onePortfolio>
				<p class="text-16-bold one-portfolio">{{ portfolioSchemas[0].name }}</p>
			</ng-template>
		</div>
		<div class="margin-standard">
			<ac-chart
				class="chart-wrapper-desktop hidden-sm"
				[highChartsAttributes]="{
					chartType: 'stacked-group-column',
					tabData: data.tabs[scenarioAnalysisTabIndex],
					colors: colors,
					portfolioIndex: portfolioIndex
				}"
			></ac-chart>
			<ac-multi-chart [multiChartModels]="chartMetaInfo" class="chart-wrapper-mobile hidden d-block-sm"></ac-multi-chart>
		</div>

		<div class="legend-container text-14 margin-standard">
			<div class="portfolio" *ngFor="let displayPortfolio of displayPortfolios">
				<span class="legend-title">{{ displayPortfolio.name }}</span>
				<ul>
					<li>
						<div class="legend-item">
							<div class="square" [ngStyle]="{ background: displayPortfolio.colors[0] }"></div>
							<span dcrHTMLKey="SCENARIO_ANALYSIS_LEGEND_EQUITY">Equity</span>
						</div>
					</li>
					<li>
						<div class="legend-item">
							<div class="square" [ngStyle]="{ background: displayPortfolio.colors[1] }"></div>
							<span dcrHTMLKey="SCENARIO_ANALYSIS_LEGEND_FIXED_INCOME">Fixed Income</span>
						</div>
					</li>
					<li>
						<div class="legend-item">
							<div class="square" [ngStyle]="{ background: displayPortfolio.colors[2] }"></div>
							<span dcrHTMLKey="SCENARIO_ANALYSIS_LEGEND_MULTI_ASSET">Multi Asset</span>
						</div>
					</li>
					<li>
						<div class="legend-item">
							<div class="square" [ngStyle]="{ background: displayPortfolio.colors[3] }"></div>
							<span dcrHTMLKey="SCENARIO_ANALYSIS_LEGEND_ALTERNATIVES">Alternatives</span>
						</div>
					</li>
					<li>
						<div class="legend-item">
							<div class="square" [ngStyle]="{ background: displayPortfolio.colors[4] }"></div>
							<span dcrHTMLKey="SCENARIO_ANALYSIS_LEGEND_OTHER">Other</span>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<section class="disclaimer-container margin-standard" dcrHTMLKey="SCENARIO_ANALYSIS_DISCLOSURE">SCENARIO_ANALYSIS_DISCLOSURE</section>
	</section>
	<bfa-modal [(isVisible)]="isScenarioAnalysisDetailsModalVisible" [enableClose]="true" [enableBackdrop]="true" width="800px">
		<div class="scenario-info">
			<div class="content">
				<div class="header"><span class="text-20-bold" dcrHTMLKey="SCENARIO_DETAILS_MODAL_TITLE">Scenario Details</span></div>
				<div class="sub-header-wrapper">
					<div class="text-14-bold col-6 left-sub-title" dcrHTMLKey="SCENARIO_DETAILS_MODAL_SUB_TITLE_1">Scenario</div>
					<div class="text-14-bold col-18" dcrHTMLKey="SCENARIO_DETAILS_MODAL_SUB_TITLE_2">Explanation</div>
				</div>
				<div class="inner-content">
					<div *ngFor="let scenarioInfo of scenarioModalInfo" class="content-wrapper">
						<div class="text-14 col-6"><p [dcrHTMLKey]="scenarioInfo.subTitleKey" [innerHtml]="scenarioInfo.subTitle"></p></div>
						<div class="text-14 col-18"><p [dcrHTMLKey]="scenarioInfo.descriptionKey" [innerHtml]="scenarioInfo.description"></p></div>
					</div>
				</div>
			</div>
		</div>
	</bfa-modal>
</ng-container>
